import React, { memo } from 'react';
import { defineMessages, useIntl } from 'react-intl';

import { DotsLoader } from '@components/Loaders/index';

import VitallLogo from '@images/logos/vitall-stacked-white-logo.svg';

import { CenterContents, Img, PageMask, Spacer } from './PageLoader.style';

const messages = defineMessages({
  preparing: {
    id: 'pageLoader.preparing',
    defaultMessage: 'Preparing your profile',
  },
});

function PageLoader() {
  const { formatMessage } = useIntl();

  return (
    <PageMask>
      <CenterContents>
        <Img alt="VITALL Logo" src={VitallLogo} />
        <Spacer />
        <DotsLoader size="11px" />
        <Spacer />
        <div>{formatMessage(messages.preparing)}</div>
      </CenterContents>
    </PageMask>
  );
}

export default memo(PageLoader);
